/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckTravelDocument } from './PaxCheckTravelDocument';
import {
    PaxCheckTravelDocumentFromJSON,
    PaxCheckTravelDocumentFromJSONTyped,
    PaxCheckTravelDocumentToJSON,
    PaxCheckTravelDocumentToJSONTyped,
} from './PaxCheckTravelDocument';

/**
 * Request to provide manually input travel document data to try resolve checklist item(s). When `checklist_item_id` is provided, travel document data applies directly to checklist item by its id. Otherwise, travel document data is applied to all checklist items with `TRAVEL_DOCUMENT` type.
 * @export
 * @interface PaxCheckApplyTravelDocumentRequest
 */
export interface PaxCheckApplyTravelDocumentRequest {
    /**
     * 
     * @type {PaxCheckTravelDocument}
     * @memberof PaxCheckApplyTravelDocumentRequest
     */
    travelDocument: PaxCheckTravelDocument;
    /**
     * Whether to ignore potential data mismatches and accept travel document data provided (unless mismatch to booking data). It will be added to DCS, but not verified until scanned/uploaded
     * @type {boolean}
     * @memberof PaxCheckApplyTravelDocumentRequest
     */
    ignoreMistakes: boolean;
}

/**
 * Check if a given object implements the PaxCheckApplyTravelDocumentRequest interface.
 */
export function instanceOfPaxCheckApplyTravelDocumentRequest(value: object): value is PaxCheckApplyTravelDocumentRequest {
    if (!('travelDocument' in value) || value['travelDocument'] === undefined) return false;
    if (!('ignoreMistakes' in value) || value['ignoreMistakes'] === undefined) return false;
    return true;
}

export function PaxCheckApplyTravelDocumentRequestFromJSON(json: any): PaxCheckApplyTravelDocumentRequest {
    return PaxCheckApplyTravelDocumentRequestFromJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyTravelDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'travelDocument': PaxCheckTravelDocumentFromJSON(json['travel_document']),
        'ignoreMistakes': json['ignore_mistakes'],
    };
}

export function PaxCheckApplyTravelDocumentRequestToJSON(json: any): PaxCheckApplyTravelDocumentRequest {
    return PaxCheckApplyTravelDocumentRequestToJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentRequestToJSONTyped(value?: PaxCheckApplyTravelDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'travel_document': PaxCheckTravelDocumentToJSON(value['travelDocument']),
        'ignore_mistakes': value['ignoreMistakes'],
    };
}

